import type { NuevaReserva } from '@medchoice/shared';

// La reserva viaja de la pantalla de reserva a la pasarela de pago en la sesión
// del navegador, no en la dirección: no tiene sentido compartirla ni guardarla.
const CLAVE = 'medchoice.reserva';

export interface ReservaPendiente {
  reserva: NuevaReserva;
  profesional: string;
  servicio: string;
  sena: number;
}

export function guardarReserva(pendiente: ReservaPendiente): void {
  sessionStorage.setItem(CLAVE, JSON.stringify(pendiente));
}

export function leerReserva(): ReservaPendiente | null {
  const guardada = sessionStorage.getItem(CLAVE);
  if (!guardada) return null;
  try {
    return JSON.parse(guardada) as ReservaPendiente;
  } catch {
    return null;
  }
}

export function olvidarReserva(): void {
  sessionStorage.removeItem(CLAVE);
}
